var React = require('react');

function AsanaShip (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M13.651,17c0,0-3.812-7.123-4.453-8.288\n\tC8.319,7.113,6.309,6.53,4.711,7.41C3.114,8.29,2.53,10.3,3.41,11.897c0.291,0.53,1.303,2.365,1.594,2.894\n\tC6.509,17.527,8.318,17,11.222,17s17.103,0,17.103,0s-14.199,0-17.103,0c-4.162,0-4.143,3.919-2.725,6.375C9.846,25.712,13,33,18,33\n\tc2.583,0,4.24-1.56,5.42-2.831C27.816,25.435,37,14,37,14v-4L18.275,25.629l-2.785-5.197"}));
}

AsanaShip.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = AsanaShip;

AsanaShip.default = AsanaShip;
